import { render, staticRenderFns } from "./AssignPickupBulkHistoryModal.vue?vue&type=template&id=0bd32973&scoped=true&"
import script from "./AssignPickupBulkHistoryModal.vue?vue&type=script&lang=ts&"
export * from "./AssignPickupBulkHistoryModal.vue?vue&type=script&lang=ts&"
import style0 from "./AssignPickupBulkHistoryModal.vue?vue&type=style&index=0&id=0bd32973&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd32973",
  null
  
)

export default component.exports